// Generated by purs version 0.13.8
"use strict";
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Select = require("../Select/index.js");
var setToggleProps = Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Events.onFocus(function (v) {
    return Data_Maybe.Just.create(new Select.SetVisibility(Select.On.value));
}), Halogen_HTML_Events.onMouseDown(function ($6) {
    return Data_Maybe.Just.create(Select.ToggleClick.create($6));
}), Halogen_HTML_Events.onKeyDown(function ($7) {
    return Data_Maybe.Just.create(Select.Key.create($7));
}), Halogen_HTML_Events.onBlur(function (v) {
    return Data_Maybe.Just.create(new Select.SetVisibility(Select.Off.value));
}), Halogen_HTML_Properties.tabIndex(0), Halogen_HTML_Properties.ref("select-input") ]);
var setItemProps = function (index) {
    return Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Events.onMouseDown(function (ev) {
        return new Data_Maybe.Just(new Select.Select(new Select.Index(index), new Data_Maybe.Just(ev)));
    }), Halogen_HTML_Events.onMouseOver(function (v) {
        return Data_Maybe.Just.create(new Select.Highlight(new Select.Index(index)));
    }) ]);
};
var setInputProps = Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Events.onFocus(function (v) {
    return Data_Maybe.Just.create(new Select.SetVisibility(Select.On.value));
}), Halogen_HTML_Events.onKeyDown(function ($8) {
    return Data_Maybe.Just.create(Select.Key.create($8));
}), Halogen_HTML_Events.onValueInput(function ($9) {
    return Data_Maybe.Just.create(Select.Search.create($9));
}), Halogen_HTML_Events.onMouseDown(function (v) {
    return Data_Maybe.Just.create(new Select.SetVisibility(Select.On.value));
}), Halogen_HTML_Events.onBlur(function (v) {
    return Data_Maybe.Just.create(new Select.SetVisibility(Select.Off.value));
}), Halogen_HTML_Properties.tabIndex(0), Halogen_HTML_Properties.ref("select-input") ]);
var setContainerProps = Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Events.onMouseDown(function ($10) {
    return Data_Maybe.Just.create(Select.PreventClick.create($10));
}) ]);
module.exports = {
    setToggleProps: setToggleProps,
    setInputProps: setInputProps,
    setItemProps: setItemProps,
    setContainerProps: setContainerProps
};
